import React, { useEffect, useState } from 'react';
import {Button, InputGroup} from 'react-bootstrap';

import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './BookingResources.scss';
import Field from '../../../Shared/Wizard/Field/Field';
import { toast } from 'react-toastify';
import Bookingcalendar from '../../../Shared/Bookingcalendar/Bookingcalendar';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import {dateFunctions} from "../../../Shared/Helpers/DateHelpers"

function BookingResources(props) {
    const t = useTranslate();
    
    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [selectedDeal, setSelectedDeal] = useState([]);

    let dateOverlap = false as Boolean;

    function getPriceAndUnit(resource) {
        let output = {unit: "", price: ""};

        function getPriceByUnit(priceList, unit) {
            if (unit == "") {
                return priceList[0].price;
            } else {
                return priceList.find(p => p.unit == unit)?.price ?? priceList[0].price;
            }
        }
        let exactPrices: Array<any> = [];
        let subcatPrices: Array<any> = [];
        let catPrices: Array<any> = [];

        if (selectedDeal != undefined) {
            exactPrices = selectedDeal["priceList"].filter(i => i.resource == resource.resource);
            subcatPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            catPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
        }

        if (exactPrices.length > 0) {
                output.price = getPriceByUnit(exactPrices, resource.unit);
                output.unit = exactPrices[0].unit;
        } else if (subcatPrices.length > 0) {
                output.price = getPriceByUnit(subcatPrices, resource.unit);
                output.unit = subcatPrices[0].unit;
        } else if (catPrices.length > 0) {
                output.price = getPriceByUnit(catPrices, resource.unit);
                output.unit = catPrices[0].unit;
        } else {
            let defaultDeal = props.allDeals.find(item => item.isDefaultDeal != false);

            let exactPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resource == resource.resource);
            let subcatPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            let catPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
            
            if (exactPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(exactPricesDefaultDeal, resource.unit);
                output.unit = exactPricesDefaultDeal[0].unit;
            } else if (subcatPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(subcatPricesDefaultDeal, resource.unit);
                output.unit = subcatPricesDefaultDeal[0].unit;
            } else if (catPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(catPricesDefaultDeal, resource.unit);
                output.unit = catPricesDefaultDeal[0].unit;
            }
        }

        return output;
    }
    
    function addSpecificResourceList(resource) {
        let tmpAllResources = props.allResources;
        let tempBooking = props.booking;

        if (tempBooking["resources"] == undefined) {
            tempBooking["resources"] = [];
        }

        let foundResource = tmpAllResources.find(i => i._id == resource._id);
        foundResource["changed"] = true;
        let resourceReservedForBookingEvent = tempBooking.events?.map(e => e._id).filter(value => foundResource.bookings.map(b => b.eventId.toString()).includes(value)) ?? [];

        let newResource = {
            resourceType: resource.resourceType,
            resourceSubtype: resource.resourceSubtype,
            resource: resource._id,
            unit: "",
            price: ""
        };

        let unitPrice = getPriceAndUnit(newResource);
        newResource.price = unitPrice.price;
        newResource.unit = unitPrice.unit;

        if(newResource.price == undefined || newResource.price == ""){
            notifyWarning(t("booking.resources.missing_price_current"));
            return undefined;
        }
        
        let newResourceBooking: any = {
            bookingId: props.booking._id,
            eventId: props.booking.events?.map(event => event._id) ?? [],
            bookingtimes: [],
            people: [],
            state: "new",
            uuid: uuidv4()
        };

        if(resourceReservedForBookingEvent.length > 0){
            newResourceBooking = undefined;

            let tmpResourceBooking = foundResource.bookings.find(b => b.eventId.find(id => id.toString() == resourceReservedForBookingEvent.toString()));
            foundResource.bookings = foundResource.bookings.filter(b => !b.eventId.includes(resourceReservedForBookingEvent.toString()));
            if(tmpResourceBooking.state == "reserved"){
                newResourceBooking = {
                    ...tmpResourceBooking, 
                    bookingId: tempBooking._id,
                    state: "exists",
                    bookingtimes: []
                };
            }
            else return ;

        } 

        if (props.events == undefined || props.booking.events == undefined || props.booking.events.length == 0) {
            if (props.booking.arrivaldate != undefined && props.booking.departuredate != undefined) {
                if(foundResource.bookings != undefined && foundResource.bookings.length > 0){
                    foundResource.bookings.forEach(booking => { 
                        if(booking.bookingtimes.length > 0) {
                            booking.bookingtimes.forEach(time => {
                                if(dateFunctions.checkDateOverlap({ start: time.start, end: time.end}, { start: props.booking.arrivaldate, end: props.booking.departuredate }) === true) {
                                    dateOverlap = true;
                                } else {
                                    dateOverlap = false;
                                };
                            })
                        } 
                    });
                }
                if(dateOverlap === true){
                    if(window.confirm(t("booking.resources.dateOverlap_warning"))) {
                        dateOverlap = false;
                        newResourceBooking.bookingtimes.push({
                            eventId: [],
                            start: props.booking.arrivaldate,
                            end: props.booking.departuredate,
                            uuid: uuidv4()
                        });
                    } else {
                            
                    } 
                } else {
                    newResourceBooking.bookingtimes.push({
                        eventId: [],
                        start: props.booking.arrivaldate,
                        end: props.booking.departuredate,
                        uuid: uuidv4()
                    });
                }
            }
        } else {
            props.events.filter(event => props.booking.events.map(i => i._id).includes(event._id)).forEach(event => {
                event.periods.forEach(period => {
                    if(foundResource.bookings != undefined && foundResource.bookings.length > 0){
                        foundResource.bookings.forEach(booking => { 
                            if(booking.bookingtimes.length > 0) {
                                booking.bookingtimes.forEach(time => {
                                    if(dateFunctions.checkDateOverlap({ start: time.start, end: time.end}, { start: period.from, end: period.to }) === true) {
                                        dateOverlap = true;
                                    } else {
                                        dateOverlap = false;
                                    };
                                })
                            } 
                        });
                    } 
                    if(dateOverlap == true){
                        if(window.confirm(t("booking.resources.dateOverlap_warning"))) {
                            dateOverlap = false;
                            newResourceBooking.bookingtimes.push({
                            eventId: event._id,
                            start: period.from,
                            end: period.to,
                            uuid: uuidv4()
                            }); 
                        } else {

                        }
                    } else {
                        newResourceBooking.bookingtimes.push({
                            eventId: event._id,
                            start: period.from,
                            end: period.to,
                            uuid: uuidv4()
                        });
                    }
                });
            });
        }

        if(newResourceBooking != undefined){
            if(dateOverlap === false) {
                tempBooking["resources"].push(newResource);
            };
            foundResource.bookings.push(newResourceBooking);
        }        



        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }
        if (props.onResourceChange != undefined) {
            props.onResourceChange(JSON.parse(JSON.stringify(tmpAllResources)));
        }

        localStorage.setItem("editedItems", "true");
    }

    function deleteResourceList(key) {
        let tempBooking = props.booking;
        let tmpAllResources = props.allResources;
        let resourceId = tempBooking["resources"][key]["resource"];
        let foundResource = tmpAllResources.find(r => r._id == resourceId);

        if(foundResource.bookings.reservedFrom != undefined || foundResource.bookings.reservedFrom != ""){
            let currentBooking = foundResource.bookings.filter(i => i.bookingId == props.booking._id);
            foundResource.bookings = foundResource.bookings.filter(i => i.bookingId != props.booking._id);
            currentBooking.forEach(booking => {
                
                if(booking.reservedFrom != undefined){
                    booking.bookingtimes = booking.bookingtimes.filter(bt => bt.bookingId != tempBooking._id && bt.eventId == booking.reservedFrom);
                    booking.bookingId = "";
                    booking.state = "reserved";
                    foundResource.bookings.push(booking);
                }
                
            });
        } 

        if(foundResource != undefined && foundResource.bookings != undefined){
            foundResource.bookings = foundResource.bookings.filter(i => i.bookingId != props.booking._id);
        } 

        foundResource["changed"] = true;

        tempBooking["resources"].splice(key, 1);
        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }
        if (props.onResourceChange != undefined) {
            props.onResourceChange(JSON.parse(JSON.stringify(tmpAllResources)));
        }

        localStorage.setItem("editedItems", "true");
    }

    const handleOnChangeUnit= (val, key, resource) => {
        let tmpResourceList = props.booking.resources;
        let tempBooking = props.booking;
        resource.unit = val.value;

        let unitPrice = getPriceAndUnit(resource);

        tmpResourceList[key]["unit"] = val.value;
        tempBooking["resources"] = tmpResourceList;
        
        if(val.value != "" ){
            tmpResourceList[key]["price"] = unitPrice.price;
        } else if(val.value == "") {
            tmpResourceList[key]["price"] = "0";
        }

        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }

        localStorage.setItem("editedItems", "true");
    }

    const restorePrice = (key, resourceType, resourceSubtype, resource, unit) =>{
        let tmpResourceList = props.booking.resources;
        let tempBooking = props.booking;

        if(tmpResourceList[key]["price"] !=  undefined && tmpResourceList[key]["price"] != ""){
            tmpResourceList[key]["overridePrice"] = undefined;
            tempBooking["resources"] = tmpResourceList;
        } else {
            notifyWarning(t("booking.resources.toast_findnoprice_invalid")); return undefined; 
        }
        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }

        localStorage.setItem("editedItems", "true");
    }

    const handleChangePrice = (val, key, orgPrice) => {
        let tmpResourceList = props.booking.resources;
        let tempBooking = props.booking;
        tmpResourceList[key]["overridePrice"] = val;

        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }

        localStorage.setItem("editedItems", "true");
    }

    function getAvailableUnits(resourceType, resourceSubtype, resource) {
        let exactPrices = selectedDeal != undefined ? selectedDeal["priceList"].filter(i => i.resource == resource) : undefined;
        let subcatPrices = selectedDeal != undefined ? selectedDeal["priceList"].filter(i => i.resourceType == resourceType && i.resourceSubtype == resourceSubtype && i.resource == "") : undefined;
        let catPrices = selectedDeal != undefined ? selectedDeal["priceList"].filter(i => i.resourceType == resourceType && i.resourceSubtype == "") : undefined;

        if (exactPrices != undefined && exactPrices.length > 0) {
            return exactPrices.map(item => { return { label: item.unit, value: item.unit }});
        } else if (subcatPrices != undefined && subcatPrices.length > 0) {
            return subcatPrices.map(item => { return { label: item.unit, value: item.unit }});
        } else if (catPrices != undefined && catPrices.length > 0) {
            return catPrices.map(item => { return { label: item.unit, value: item.unit }});
        } else {
            let defaultDeal = props.allDeals.find(item => item.isDefaultDeal != false);
            if (defaultDeal != undefined) {
                let exactPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resource == resource);
                let subcatPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resourceType && i.resourceSubtype == resourceSubtype && i.resource == "");
                let catPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resourceType && i.resourceSubtype == "");

                if (exactPricesDefaultDeal != undefined && exactPricesDefaultDeal.length > 0) {
                    return exactPricesDefaultDeal.map(item => { return { label: item.unit, value: item.unit }});
                } else if (subcatPricesDefaultDeal != undefined && subcatPricesDefaultDeal.length > 0) {
                    return subcatPricesDefaultDeal.map(item => { return { label: item.unit, value: item.unit }});
                } else if (catPricesDefaultDeal != undefined && catPricesDefaultDeal.length > 0) {
                    return catPricesDefaultDeal.map(item => { return { label: item.unit, value: item.unit }});
                } else {
                    return [];
                }
            } else {
                return [];
            }
        }
    }

    function getResources() {
        if (props.allResources != undefined && props.allResourceTypes != undefined) {
            let tempresources = props.allResources;
    
            tempresources = tempresources.map(resource => {
                return {
                    ...resource,
                    resourceTypeName: props.allResourceTypes.find(i => i._id == resource.resourceType)["name"],
                    bookings: resource.bookings.map(b => { return { ...b, state: "existing" } } )
                }
            });
            return tempresources;
        } else {
            return [];
        }
    }

    useEffect(() => {
        let selectedDeal = props.booking.deal != undefined ? 
            props.allDeals.find(deal => deal["_id"] == props.booking.deal._id)
        :
            props.allDeals != undefined ?
                props.allDeals.find(item => item.isDefaultDeal != false)
            : "";

        setSelectedDeal(selectedDeal);
    }, [props]);

    return (
        <div style={{ marginTop: '20px' }}>
            <h3>{t("booking.resources.calendartitle")}</h3>
            <hr/>
            <p>{t("booking.resources.calendardescription")}</p>
            <Bookingcalendar
                fetchDataPass={() => {
                    if (props.fetchDataPass != undefined) {
                        props.fetchDataPass();
                    }
                }}
                event={props.booking.event}
                forceUpdate={props.forceUpdate}
                resources={getResources()}
                bookingId={props.booking._id}
                height={"600px"}
                onChange={(resources) => {
                    if (props.onResourcesChange != undefined) {
                        props.onResourcesChange(JSON.parse(JSON.stringify(resources)));
                    }
                    localStorage.setItem("editedItems", "true");
                }}
                resourceClicked={(resource) => {
                    if (props.booking.resources != undefined) {
                        if (!props.booking.resources.map(r => r.resource).includes(resource._id)) {
                            addSpecificResourceList(resource);
                        }
                    } else {
                        addSpecificResourceList(resource);
                    }
                }}
                dateClick={(evt) => {
                    let tempresources = props.allResources;

                    let clickedResource = tempresources.find(i => i._id == evt.resource._resource.id);

                    if (clickedResource != undefined) {
                        let foundBooking = clickedResource.bookings != undefined ? clickedResource.bookings.find(i => i.bookingId == props.booking._id) : undefined;

                        if (foundBooking != undefined) {
                            foundBooking.bookingtimes.push({
                                bookingId: props.booking._id,
                                eventId: "",
                                start: moment(evt.date).add(1, "hours").toDate(),
                                end: moment(evt.date).add(25, "hours").toDate(),
                                uuid: uuidv4(),
                                state: "new"
                            });
                        } else {
                            notifyWarning(t("booking.resources.add_before_assigning_time"));
                        }
                    }

                    if (props.onResourcesChange != undefined) {
                        props.onResourcesChange(JSON.parse(JSON.stringify(tempresources)));
                    }
                    localStorage.setItem("editedItems", "true");
                }}
                eventClick={(evt) => {
                    
                }}
            ></Bookingcalendar>
            <hr/>
            <h3>{t("booking.resources.resourcestitle")}</h3>
            <table className="table resourcedefinitiontable">
                <thead>
                    <tr>
                        <th>{t("booking.resources.resrouce")}</th>
                        <th>{t("booking.resources.unit")}</th>
                        <th>{t("booking.resources.price")}</th>
                    </tr>
                </thead>
                <tbody>
                    { props.booking.resources != undefined && props.allResources.length > 0 ? props.booking.resources.map((item, key) => 
                        <tr key={key}>
                            <td style={{ padding: "0px" }}>
                                <p className="resourcename">{props.allResources.find(i => i._id == item["resource"]).name}</p>
                            </td>
                            <td style={{ padding: "0px" }}>
                                <Field
                                    type="select"
                                    value={{value: item["unit"], label: item["unit"]}}
                                    onChange={(val) => {
                                        handleOnChangeUnit(val, key, item)
                                    }}
                                    options={{
                                        choices: getAvailableUnits(item["resourceType"], item["resourceSubtype"], item["resource"]) //props.allDeals != undefined ? ((props.allDeals.find(i => i["resourceType"] == item["resourceType"]) || props.allDeals.find(i => i["resourceSubtype"] == item["resourceSubtype"])|| {})["unit"] || []).map(i => { return { label: i, value: i } }) : [] 
                                    }}
                                ></Field>
                            </td>
                            <td style={{ padding: "0px", width: "347px" }}>
                                <div className="row">
                                    <div className="col col-sm-4">
                                        <Field
                                            type="input"
                                            value={item["overridePrice"] !== undefined ? item["overridePrice"] : item["price"]}
                                            onChange={value => handleChangePrice(value, key, item["price"]) }
                                        ></Field> 
                                    </div>
                                    <div className="col col-sm-8">
                                        <p id="tag-icon" style={{ float: "left", marginRight: "20px", marginTop: "6px"}}>{item["overridePrice"] !== undefined ? <i  className="dripicons-tag" />: ""}</p>
                                        <InputGroup.Append style={{ float: "left", marginRight: "6px" }}>
                                            <Button onClick={(evt) => restorePrice(key, item["resourceType"], item["resourceSubtype"], item["resource"], item["unit"])}>{t("booking.resources.restoreprice")}</Button>
                                        </InputGroup.Append>
                                        <InputGroup.Append style={{ float: "right"}}>
                                            <Button onClick={(evt) => deleteResourceList(key)}>{t("booking.resources.resource_delete")}</Button>
                                        </InputGroup.Append>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ) : null}
                </tbody>
            </table>
            <hr />
        </div>
    );
}

export default BookingResources;